module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAAkElEQVQ4ja3T0Q3DMAhFUTpKM0enbzpIPcntR5NITox5jkFC/KAjBMIAE/IJvLca9qvgl38UBR4BUeFRUIJ7YHHAEL4LduEZ0IVnwSacAV7gLLCCH8BqZi/Li48BS/Kky77TDLhsTnX9GfgAz+hduAJb6Ch8AT1UhZtgD41gF4xQD+6CCnr+uBBU0R1eFRCwH1xgs99OWZA3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/custom-bullet-active.png
// module id = i9CL
// module chunks = 0